module.exports = __webpack_public_path__ + "img/adquirir.b509a97c.png";